import { partial, struct, union } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const RequestData = union(
	struct({
		iCommand: partial({
			jobNumber: iotsUtils.NotEmptyString,
		}),
	})
);
